import React from "react";
import MarketplaceList from "../components/MarketplaceList";

export default function MarketplaceHome() {
  return (
    <div className="container">
        <h1 className="text-3xl font-bold my-6" style={{ marginLeft: "120px" }}>
        Carbon Certificate Marketplace
      </h1>      
      <MarketplaceList />
    </div>
  );
}
